import { CanDeactivateFn } from "@angular/router";

import { CredentialsMaintenanceComponent } from "../credentials-maintenance.component";

export const preventRouteChangeGuard: CanDeactivateFn<
  CredentialsMaintenanceComponent
> = (component, _currentRoute, _currentState, nextState): boolean => {
  const isCredentialSubPage =
    nextState.url.includes("credentials-maintenance") ||
    nextState.url === "/purchase/checkout/certification?isRecertify=true";

  if (component.isRecertify && !isCredentialSubPage) {
    return window.confirm(
      "You didn’t ‘Recertify Now’. Are you sure you want to exit?"
    );
  }

  return true;
};